export default {
  de: {

  },
  en: {

  }
}
